import { Booking } from '@deliveries-app/models';
import numeral from 'numeral';
import { countTotalPrice } from '../../../utils/helpers';

interface ProductsProps {
  booking: Booking;
}

export default function Products({ booking }: ProductsProps) {
  return (
    <div className="mt-5 overflow-x-auto rounded border border-gray-300 bg-gray-50">
      <table className="w-full min-w-full divide-y divide-gray-300 text-sm">
        <thead className="">
          <tr>
            <td className="whitespace-nowrap rounded-bl-md py-4 px-2 pl-5">
              Product Name
            </td>
            <td className="whitespace-nowrap rounded-tr-md rounded-br-md px-3">
              Notes
            </td>
            <td className="whitespace-nowrap px-2">Quantity</td>
            <td className="whitespace-nowrap px-2">Weight</td>
            <td className="whitespace-nowrap px-2">Volume</td>
            <td className="whitespace-nowrap px-2">Price</td>
          </tr>
        </thead>
        <tbody className="bg-white">
          {booking.booking_line.map((val, index) => {
            return (
              <tr key={index} className="">
                <td className="py-4 px-2 pl-5 text-sm">{val.product.name}</td>
                <td className="px-2">{val.notes}</td>
                <td className="px-2">{val.quantity}</td>
                <td className="px-2">{val.weight}</td>
                <td className="px-2">{val.volume}</td>
                <td className="px-4 text-right">
                  {numeral(val.price).format('$0,0.00')}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex flex-row justify-end border-t border-gray-300 bg-white py-2 px-4 text-sm">
        <div className="w-1/3 space-y-0.5">
          <div className="flex flex-1">
            <div className="w-1/2 text-right">Product Prices</div>
            <div className="w-1/2 text-right">
              {numeral(
                countTotalPrice(
                  booking.booking_line,
                  booking.financial.delivery_fee
                ).totalPrice
              ).format('$0,0.00')}
            </div>
          </div>
          <div className="flex flex-1">
            <div className="w-1/2 text-right">Delivery Fee</div>
            <div className="w-1/2 text-right">
              {booking.financial.delivery_fee &&
                numeral(booking.financial.delivery_fee).format('$0,0.00')}
            </div>
          </div>
          <div className="flex flex-1 font-bold">
            <div className="w-1/2 text-right">Total Price</div>
            <div className="w-1/2 text-right">
              {numeral(
                countTotalPrice(
                  booking.booking_line,
                  booking.financial.delivery_fee
                ).totalAmount
              ).format('$0,0.00')}
            </div>
          </div>
          <div className="flex flex-1">
            <div className="w-1/2 text-right">Delivery Cost</div>
            <div className="w-1/2 text-right">
              {/* {booking.cost && numeral(booking.cost).format('$0,0.00')} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
